<nav aria-label="breadcrumb">
    <ol class="breadcrumb">
        <li class="breadcrumb-item">
            <a routerLink="/dashboard" style="color: #003E53;">Dashboard</a>
        </li>
        <li class="breadcrumb-item">
            <a routerLink="/company" style="color: #003E53;">{{ companyDetail?.name || 'Company' }}</a>
        </li>

        <li class="breadcrumb-item active" aria-current="page">
            Distributors
        </li>
    </ol>
</nav>

<div class="row compact-content">
    <div class="col-xl-12">
        <app-card cardTitle="Basic Table" [options]="false" blockClass="table-border-style">
            <div class="row  gx-3">
                <div class="col-md-6 col-12 mb-2 mb-md-0">
                    <h5 class="mb-0 text-dark fw-bold">Distribution Network of &nbsp;<span style="color:#003E53">{{
                            companyDetail?.name }}</span></h5>
                </div>
                <div class="col-md-6 col-12">
                    <div class="d-flex justify-content-md-end align-items-center gap-3 flex-wrap">
                        <div class="flex-grow-1 text-md-end text-start">
                            <h5 class="fw-semibold mb-1 text-dark">{{ companyDetail?.name || 'Company' }}</h5>
                            @if(companyDetail?.email || companyDetail?.phone) {
                            <div class="d-flex flex-wrap justify-content-md-end gap-2">
                                @if(companyDetail?.email) {
                                <a class="text-muted small text-decoration-none d-flex align-items-center">
                                    <i class="bi bi-envelope me-1 fs-7"></i>
                                    <span class="text-truncate" style="max-width: 140px;">{{ companyDetail.email
                                        }}</span>
                                </a>
                                }
                                @if(companyDetail?.phone) {
                                <a class="text-muted small text-decoration-none d-flex align-items-center">
                                    <i class="bi bi-telephone me-1 fs-7"></i>
                                    {{ companyDetail.phone }}
                                </a>
                                }
                            </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
            <hr class="m-0 p-o">
            <hr class="m-0 p-o">

            <div class="row">
                <div class="col-lg-4 ">
                    <div class="">
                        <ng-select [(ngModel)]="selectedRecipientType" (change)="onRecipientChange($event)"
                            placeholder="Select Recipient Type" class="text-dark">
                            <ng-option value='Wholesaler'>Wholesaler</ng-option>
                            <ng-option value='Retailer'>Retailer</ng-option>
                            <ng-option value='Customer'>Customer</ng-option>
                        </ng-select>

                    </div>
                </div>

                <div class="col-lg-3">
                    <mat-form-field mappearance="outline" class="dense w-100">
                        <mat-label>Search By Name or Email</mat-label>
                        <input matInput [(ngModel)]="filter.name" name="name" (input)="onNameInputChange($event)">
                    </mat-form-field>
                </div>
                <div class="col-lg-3">
                    <mat-form-field mappearance="outline" class="dense w-100">
                        <mat-label>Search By Address</mat-label>
                        <input matInput [(ngModel)]="filter.cityState" name="barCode"
                            (input)="onBarAddressInputChange($event)">
                    </mat-form-field>
                </div>
            </div>

            @if(selectedRecipientType=='Wholesaler'||selectedRecipientType=='Retailer'){
            <ng-container>
                <div class="table-responsive">
                    <div class="mat-elevation-z8">
                        <table mat-table [dataSource]="dataSource" class="table-bordered compact-table ">
                            <!-- Position Column -->
                            <ng-container matColumnDef="srno">
                                <th mat-header-cell *matHeaderCellDef>Sr. No</th>
                                <td mat-cell *matCellDef="let row; let index = index">
                                    {{ index + 1 + (paginator.pageIndex * paginator.pageSize) }}
                                </td>
                            </ng-container>

                            <!-- Name Column -->
                            <ng-container matColumnDef="name">
                                <th mat-header-cell *matHeaderCellDef class="text-center"> Name </th>
                                <td mat-cell *matCellDef="let element" class="text-nowrap">
                                    <div class="d-flex flex-column gap-1">
                                        <div><i class="bi bi-person-fill me-1 text-secondary"></i> {{
                                            element.distributor?.name }}</div>

                                    </div>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="contact">
                                <th mat-header-cell *matHeaderCellDef class="text-center"> Contact </th>
                                <td mat-cell *matCellDef="let element" class="text-nowrap">
                                    <div class="d-flex flex-column gap-1">

                                        <div>
                                            <i class="bi bi-envelope-fill me-1 text-secondary"></i> {{
                                            element.distributor?.email }}
                                        </div>
                                        <div><i class="bi bi-telephone-fill me-1 text-secondary"></i> {{
                                            element.distributor?.phone }}</div>
                                    </div>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="cordinates">
                                <th mat-header-cell *matHeaderCellDef class="text-center">
                                    Coordinates (Lng, Lat)
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    {{ element.distributor?.location?.coordinates[0] }}<br>
                                    {{ element.distributor?.location?.coordinates[1] }}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="address">
                                <th mat-header-cell *matHeaderCellDef class="text-center"> Address </th>
                                <td mat-cell *matCellDef="let element" class="text-nowrap"
                                    (click)="element.showFull = !element.showFull" style="cursor: pointer;">
                                    @if (!element.showFull) {
                                    {{ getTruncatedAddress(element.distributor?.address, 4) }},
                                    <br />
                                    {{ element.distributor?.city }},
                                    {{ element.distributor?.state }}
                                    } @else {
                                    {{ element.distributor?.address }},
                                    <br />
                                    {{ element.distributor?.city }},
                                    {{ element.distributor?.state }}
                                    }
                                </td>

                            </ng-container>

                            <ng-container matColumnDef="samples">
                                <th mat-header-cell *matHeaderCellDef class="text-center"> Issued <br>
                                    Samples </th>
                                <td mat-cell *matCellDef="let element" class="text-nowrap text-center">
                                    <button class="btn btn-sm c_btn"
                                        [routerLink]="['/company/samples/distributed', companyId, element.distributor?._id, selectedRecipientType === 'Wholesaler' ? 1 : selectedRecipientType === 'Retailer' ? 2 : null]"
                                        aria-label="View Issued Samples">
                                        <i class="bi-box-arrow-up"></i>
                                    </button>

                                </td>
                            </ng-container>

                            <ng-container matColumnDef="retailers">
                                <th mat-header-cell *matHeaderCellDef class="text-nowrap">
                                    @if(selectedRecipientType=='Wholesaler'){

                                    Retailers
                                    }
                                    @if(selectedRecipientType=='Retailer'){

                                    Customers
                                    }

                                </th>
                                <td mat-cell *matCellDef="let element">

                                    <button mat-icon-button class="btn btn-sm c_btn"
                                        (click)="openRtlUnderWhlModel(element.distributor?._id)">
                                        <i class="bi bi-shop"></i>
                                    </button>
                                </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="displayedColumns" class="t_head p-1"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="p-1"></tr>
                            <tr class="mat-row" *matNoDataRow>
                                <td class="mat-cell text-center" [attr.colspan]="displayedColumns.length">
                                    No data available
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
                <mat-paginator #paginator [length]="total" [pageSize]="pageSize" [pageSizeOptions]="[10, 20, 50, 100]"
                    (page)="getAllDistributors($event)">
                </mat-paginator>
            </ng-container>
            }
            @else{
            <ng-container>
                <div class="table-responsive mt-2">
                    <div class="mat-elevation-z8">
                        <table mat-table [dataSource]="dataSource" class="table-bordered compact-table">
                            <!-- Position Column -->
                            <ng-container matColumnDef="srno">
                                <th mat-header-cell *matHeaderCellDef>Sr. No</th>
                                <td mat-cell *matCellDef="let row; let index = index">
                                    {{ index + 1 + (paginator.pageIndex * paginator.pageSize) }}
                                </td>
                            </ng-container>

                            <!-- Name Column -->
                            <ng-container matColumnDef="name">
                                <th mat-header-cell *matHeaderCellDef class="text-center"> Name </th>
                                <td mat-cell *matCellDef="let element" class="text-nowrap">
                                    {{element?.name}} </td>
                            </ng-container>

                            <ng-container matColumnDef="email">
                                <th mat-header-cell *matHeaderCellDef class="text-center"> Email </th>
                                <td mat-cell *matCellDef="let element">
                                    @if(element?.email){
                                    {{element?.email}}

                                    }
                                    @else {
                                    -
                                    }

                                </td>
                            </ng-container>
                            <ng-container matColumnDef="phone">
                                <th mat-header-cell *matHeaderCellDef class="text-center"> Phone </th>
                                <td mat-cell *matCellDef="let element"> {{element?.phone}} </td>
                            </ng-container>
                            <ng-container matColumnDef="age">
                                <th mat-header-cell *matHeaderCellDef class="text-center"> Age </th>
                                <td mat-cell *matCellDef="let element"> {{ calculateAge(element?.dob)
                                    }}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="gender">
                                <th mat-header-cell *matHeaderCellDef class="text-center"> Gender </th>
                                <td mat-cell *matCellDef="let element">

                                    @if(element?.gender==1){
                                    Male
                                    }
                                    @else if(element?.gender==2){
                                    Female
                                    }
                                    @else if(element?.gender==3){
                                    Other
                                    }
                                    @else{
                                    -
                                    }

                                </td>
                            </ng-container>

                            <ng-container matColumnDef="address">
                                <th mat-header-cell *matHeaderCellDef class=""> Address </th>
                                <td mat-cell *matCellDef="let element" (click)="element.showFull = !element.showFull"
                                    style="cursor: pointer;">
                                    @if (!element.showFull) {
                                    {{ getTruncatedAddress(element.distributor?.address, 4) }},
                                    <br />
                                    {{ element.distributor?.city }},
                                    {{ element.distributor?.state }}
                                    } @else {
                                    {{ element.distributor?.address }},
                                    <br />
                                    {{ element.distributor?.city }},
                                    {{ element.distributor?.state }}
                                    }
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="action">
                                <th mat-header-cell *matHeaderCellDef class="text-nowrap"> Issued Samples </th>
                                <td mat-cell *matCellDef="let element">
                                    <button mat-icon-button class="btn btn-sm c_btn"
                                        (click)="openCompanyCustomersSampleModal(element?.companyDistributorId)">
                                        <i class="bi bi-box"></i>
                                    </button>
                                </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="displayedColumnsCustomer" class="t_head text-center">
                            </tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumnsCustomer;" class="text-center">
                            </tr>
                            <tr class="mat-row" *matNoDataRow>
                                <td class="mat-cell text-center" [attr.colspan]="displayedColumnsCustomer.length">
                                    No data available
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
                <mat-paginator #paginator [length]="total" [pageSize]="pageSize" [pageSizeOptions]="[10, 20, 50, 100]"
                    (page)="getAllDistributors($event)">
                </mat-paginator>
            </ng-container>
            }
        </app-card>
    </div>
</div>

<!-- rtl under whl model -->

<div class="modal fade" id="rtlUnderWhlModal" tabindex="-1" aria-labelledby="rtlUnderWhlModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-xl">
        <div class="modal-content bg-white">
            <div class="modal-header border-bottom pb-2 align-items-center bg-light py-2">
                <div class="d-flex align-items-center gap-2 w-100">
                    <!-- Company Info -->
                    <div class="flex-grow-1">
                        <h5 class="modal-title fs-6 fw-semibold mb-0 text-dark">
                            @if(selectedRecipientType=="Retailer"){
                            Customer Under Retailer: {{singleDistributor?.name}}
                            }
                            @if(selectedRecipientType=="Wholesaler"){
                            Retailers Under Wholesaler: {{singleDistributor?.name}}
                            }
                        </h5>
                    </div>
                    <button type="button" class="btn-close p-1 ms-auto opacity-50 hover-opacity-100 transition-opacity"
                        aria-label="Close" (click)="hideRtlUnderWhlModel()">
                    </button>
                </div>
            </div>
            <div class="modal-body ">
                <div class="table-responsive mt-2">
                    <div class="mat-elevation-z8">
                        <table mat-table [dataSource]="RTLUnderWHLDataSource" class="table-bordered">
                            <!-- Position Column -->
                            <ng-container matColumnDef="srno">
                                <th mat-header-cell *matHeaderCellDef>Sr. No</th>
                                <td mat-cell *matCellDef="let row; let index = index">
                                    {{ index + 1 + (paginator.pageIndex * paginator.pageSize) }}
                                </td>
                            </ng-container>
                            <!-- Name Column -->
                            <ng-container matColumnDef="name">
                                <th mat-header-cell *matHeaderCellDef> Name </th>
                                <td mat-cell *matCellDef="let element" class="text-nowrap">
                                    {{element.distributorId?.name}} </td>
                            </ng-container>
                            <ng-container matColumnDef="email">
                                <th mat-header-cell *matHeaderCellDef class=""> Email </th>
                                <td mat-cell *matCellDef="let element"> {{element.distributorId?.email}}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="phone">
                                <th mat-header-cell *matHeaderCellDef class=""> Phone </th>
                                <td mat-cell *matCellDef="let element"> {{element.distributorId?.phone}}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="coordinates">
                                <th mat-header-cell *matHeaderCellDef class=""> Coordinates </th>
                                <td mat-cell *matCellDef="let element">
                                    {{element.distributorId?.longitude}} , <br>
                                    {{element.distributorId?.latitude}}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="address">
                                <th mat-header-cell *matHeaderCellDef class=""> Address </th>
                                <td mat-cell *matCellDef="let element"> {{element.distributorId?.address}}
                                </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="RTLUnderWHLdisplayedColumns" class="t_head"></tr>
                            <tr mat-row *matRowDef="let row; columns: RTLUnderWHLdisplayedColumns;">
                            </tr>
                            <tr class="mat-row" *matNoDataRow>
                                <td class="mat-cell text-center" [attr.colspan]="RTLUnderWHLdisplayedColumns.length">
                                    No data available
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
            <div class="modal-footer border-1 pt-2 pb-2 d-flex justify-content-end">
                <button (click)="hideRtlUnderWhlModel()" type="button"
                    class="btn btn-sm btn-light text-dark py-1 px-3 fs-7">Close</button>
            </div>
        </div>
    </div>
</div>

<!-- Company Assigned Samples To Customer model -->

<div class="modal fade" id="companyCustomersSampleModal" tabindex="-1"
    aria-labelledby="companyCustomersSampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-xl">
        <div class="modal-content bg-white">
            <div class="modal-header border-bottom pb-2 align-items-center bg-light py-2">
                <div class="d-flex align-items-center gap-2 w-100">
                    <!-- Company Info -->
                    <div class="flex-grow-1">
                        <h5 class="modal-title fs-6 fw-semibold mb-0 text-dark">
                            Sample Distribution to Customers
                            <br>
                            <span class="text-muted h6">Issued By: {{ companyDetail?.name || 'Company' }}</span>
                        </h5>
                    </div>
                    <button type="button" class="btn-close p-1 ms-auto opacity-50 hover-opacity-100 transition-opacity"
                        aria-label="Close" (click)="hideCompanyCustomersSampleModal()">
                    </button>
                </div>
            </div>

            <div class="modal-body ">
                <div class="table-responsive mt-2">
                    <div class="mat-elevation-z8">
                        <table mat-table [dataSource]="companyCustomerSamplesDataSource" class="table-bordered">
                            <!-- Position Column -->
                            <ng-container matColumnDef="srno">
                                <th mat-header-cell *matHeaderCellDef>Sr. No</th>
                                <td mat-cell *matCellDef="let row; let index = index">
                                    {{ index + 1 + (paginator.pageIndex * paginator.pageSize) }}
                                </td>
                            </ng-container>
                            <!-- Name Column -->
                            <ng-container matColumnDef="sample">
                                <th mat-header-cell *matHeaderCellDef> Samples </th>
                                <td mat-cell *matCellDef="let element" class="text-nowrap">
                                    Name: {{element.sampleId?.name}}
                                    <br>
                                    Limit: {{element.sampleId?.maxIssueQuantityCustomer}}

                                </td>
                            </ng-container>
                            <ng-container matColumnDef="issuedByDistributorId">
                                <th mat-header-cell *matHeaderCellDef class=""> Distributor </th>
                                <td mat-cell *matCellDef="let element">

                                    Name : {{element.issuedByDistributorId?.name}} <br>
                                    Email : {{element.issuedByDistributorId?.email}}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="issuedQuantity">
                                <th mat-header-cell *matHeaderCellDef class=""> Issued Quantity </th>
                                <td mat-cell *matCellDef="let element"> {{element.issuedQuantity}}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="issueByHold">
                                <th mat-header-cell *matHeaderCellDef> Issued By Hold </th>
                                <td mat-cell *matCellDef="let element">
                                    {{ element.issueByHold ? 'Yes' : 'No' }}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="issuedAt">
                                <th mat-header-cell *matHeaderCellDef class=""> Issued At </th>
                                <td mat-cell *matCellDef="let element"> {{element.issuedAt | date}}
                                </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="companyCustomerSamplesdisplayedColumns" class="t_head">
                            </tr>
                            <tr mat-row *matRowDef="let row; columns: companyCustomerSamplesdisplayedColumns;">
                            </tr>
                            <tr class="mat-row" *matNoDataRow>
                                <td class="mat-cell text-center"
                                    [attr.colspan]="companyCustomerSamplesdisplayedColumns.length">
                                    No data available
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
            <div class="modal-footer border-1 pt-2 pb-2 d-flex justify-content-end">
                <button (click)="hideCompanyCustomersSampleModal()" type="button"
                    class="btn btn-sm btn-light text-dark py-1 px-3 fs-7">Close</button>
            </div>
        </div>
    </div>
</div>